(function () {
  'use strict';

  if (window.__quoteRequestModalJsLoaded) return;
  window.__quoteRequestModalJsLoaded = true;

  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  var openModal = null;
  var lastFocused = null;

  function qs(root, selector) {
    return root.querySelector(selector);
  }

  function qsa(root, selector) {
    return Array.prototype.slice.call(root.querySelectorAll(selector));
  }

  function showPanel(modal, name) {
    qsa(modal, '[data-quote-modal-panel]').forEach(function (panel) {
      var isMatch = panel.getAttribute('data-quote-modal-panel') === name;
      panel.hidden = !isMatch;
    });
  }

  function setFieldInvalid(field, isInvalid) {
    field.classList.toggle('is-invalid', isInvalid);
  }

  function validateField(field) {
    var input = qs(field, '[data-quote-field]');
    if (!input) return true;

    var name = input.getAttribute('data-quote-field');
    var value = input.value.trim();
    var valid = true;

    if (name === 'name') {
      valid = value.length > 0;
    } else if (name === 'email') {
      valid = value.length > 0 && EMAIL_RE.test(value);
    } else if (name === 'state') {
      valid = value.length > 0;
    }

    setFieldInvalid(field, !valid);
    return valid;
  }

  function validateForm(form) {
    var fields = qsa(form, '[data-quote-field-wrap]');
    var allValid = true;
    var firstInvalidInput = null;

    fields.forEach(function (field) {
      var valid = validateField(field);
      if (!valid) {
        allValid = false;
        if (!firstInvalidInput) {
          firstInvalidInput = qs(field, '[data-quote-field]');
        }
      }
    });

    if (firstInvalidInput) {
      firstInvalidInput.focus();
    }

    return allValid;
  }

  function resetForm(form) {
    form.reset();
    qsa(form, '[data-quote-field-wrap]').forEach(function (field) {
      setFieldInvalid(field, false);
    });
  }

  function openQuoteModal(modal) {
    if (openModal === modal) return;
    lastFocused = document.activeElement;
    showPanel(modal, 'form');
    modal.hidden = false;
    document.body.classList.add('quote-modal-open');
    openModal = modal;

    var nameField = qs(modal, '[data-quote-field="name"]');
    if (nameField) nameField.focus();

    document.addEventListener('keydown', onKeydown, true);
  }

  function closeQuoteModal(modal) {
    if (!modal || modal.hidden) return;
    modal.hidden = true;
    document.body.classList.remove('quote-modal-open');
    openModal = null;
    document.removeEventListener('keydown', onKeydown, true);

    var form = qs(modal, 'form');
    if (form) resetForm(form);

    // Strip Shopify's contact_posted flag (and its #QuoteRequestForm fragment)
    // from the URL so a refresh or history navigation doesn't reopen the modal
    // on the success panel forever — the Liquid template opens the modal
    // automatically whenever contact_posted=true is present.
    if (window.history && window.history.replaceState) {
      var url = new URL(window.location.href);
      var hadFlag = url.searchParams.has('contact_posted') || url.hash.indexOf('QuoteRequestForm-') !== -1;
      if (hadFlag) {
        url.searchParams.delete('contact_posted');
        url.hash = '';
        window.history.replaceState({}, '', url.toString());
      }
    }

    if (lastFocused && typeof lastFocused.focus === 'function') {
      lastFocused.focus();
    }
  }

  function onKeydown(event) {
    if (!openModal) return;

    if (event.key === 'Escape') {
      closeQuoteModal(openModal);
      return;
    }

    if (event.key === 'Tab') {
      var focusable = qsa(openModal, 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled])')
        .filter(function (el) { return el.offsetParent !== null; });

      if (!focusable.length) return;

      var first = focusable[0];
      var last = focusable[focusable.length - 1];

      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }
  }

  function handleSubmit(event) {
    var form = event.target;
    if (!form.matches('.quote-modal__form')) return;

    // Client-side validation only. If invalid, block native submission and
    // surface inline errors. If valid, let the native POST go through —
    // Shopify processes the contact form server-side and redirects back to
    // ?contact_posted=true, at which point the Liquid template re-renders
    // the modal already open on the success panel (form.posted_successfully?).
    //
    // We deliberately don't AJAX this. Shopify's /contact endpoint on this
    // store rejects XHR submissions (returns 400 even with X-Requested-With
    // and both multipart and urlencoded bodies) — likely the store's bot-
    // protection path only accepts native form POSTs with a full session
    // context. Native submission works reliably; only cost is a page reload
    // which the Liquid fallback already handles cleanly.
    if (!validateForm(form)) {
      event.preventDefault();
      return;
    }

    var submitButton = qs(form, '[data-quote-submit]');
    var submitLabel = qs(form, '[data-quote-submit-label]');
    if (submitButton) submitButton.disabled = true;
    if (submitLabel) submitLabel.textContent = 'Submitting…';
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-quote-modal-trigger]');
    if (trigger) {
      var targetId = trigger.getAttribute('data-quote-modal-target');
      var modal = targetId ? document.getElementById(targetId) : null;
      if (modal) {
        event.preventDefault();
        openQuoteModal(modal);
      }
      return;
    }

    var closer = event.target.closest('[data-quote-modal-close]');
    if (closer) {
      var closeModal = closer.closest('[data-quote-modal]');
      if (closeModal) closeQuoteModal(closeModal);
    }
  });

  document.addEventListener('submit', handleSubmit);

  document.addEventListener('blur', function (event) {
    var field = event.target.closest && event.target.closest('[data-quote-field-wrap]');
    if (field && event.target.matches('[data-quote-field]')) {
      validateField(field);
    }
  }, true);

  // Covers a real page reload after a native (non-JS) contact form submission:
  // the liquid template renders the modal already open on the success panel
  // (via form.posted_successfully?), so wire up the same open-modal state
  // (scroll lock, Escape-to-close, focus) instead of requiring a trigger click.
  var alreadyOpenModal = document.querySelector('[data-quote-modal]:not([hidden])');
  if (alreadyOpenModal) {
    document.body.classList.add('quote-modal-open');
    openModal = alreadyOpenModal;
    document.addEventListener('keydown', onKeydown, true);

    var successFocus = qs(alreadyOpenModal, '[data-quote-success-focus]');
    if (successFocus) successFocus.focus();
  }
})();
